module.exports = __webpack_public_path__ + "img/beex-logo-52x52.d7dcf8f0.png";